<template>
    <div class="input input-geo" :class="{'right': !hideButton}">
        <label :for="resolvedInputId" v-if="isShowLabel">{{placeholder}}</label>
        <input :id="resolvedInputId" type="text" ref="geo" :placeholder="placeholder" autocomplete="disabled"/>
        <button :class="btnclass"
            v-if="!hideButton"
            @click="onClick" title="Search">
            <slot>
                <i class="icon-search" ></i>
            </slot>
        </button>
    </div>
</template>
<script src="./mvt-inputgeo.js"></script>

<style lang="scss">
@use "./mvt-inputgeo.scss" as *;
</style>
